<template>
  <v-card>
    <v-bottom-nav
          color="primary"
          :value="true"
          dark
          shift
        >
          <v-btn dark @click="step = 1">
            <span>Dados pessoais</span>
            <v-icon>account_circle</v-icon>
          </v-btn>

          <v-btn dark @click="step = 2" v-if="usuario.endereco">
            <span>Endereço</span>
            <v-icon>place</v-icon>
          </v-btn>

          <v-btn dark @click="step = 3" v-if="usuario.tem_empresa">
            <span>Empresas</span>
            <v-icon>business</v-icon>
          </v-btn>

          <v-btn dark @click="step = 4" v-if="usuario.tem_posto">
            <span>Postos</span>
            <v-icon>local_gas_station</v-icon>
          </v-btn>
    </v-bottom-nav>
    <v-card-text>
      <v-stepper v-model="step" style="box-shadow: none;">
      <v-stepper-items pt-4 row wrap justify-space-around fill-height>
      <v-stepper-content step="1">
        <v-flex xs12 class="text-xs-center mb-2"><h3>Dados pessoais</h3></v-flex>
        <v-flex xs12>
          <v-text-field
            readonly
            label="Identificação do usuário"
            v-model="usuario.id_pessoa"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            readonly
            label="Nome"
            v-model="usuario.nome"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            readonly
            label="Sobrenome"
            v-model="usuario.sobrenome"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            readonly
            label="CPF"
            mask="###.###.###-##"
            class="text-xs-center"
            v-model="usuario.cpf"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            readonly
            label="Número de telefone"
            mask="(##) #####-####"
            class="text-xs-center"
            v-model="usuario.telefone"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            readonly
            label="Data de nascimento"
            v-model="usuarioDataNascimento"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            readonly
            label="Data de cadastro"
            class="text-xs-center"
            v-model="usuarioDataCadastro"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            readonly
            label="Email do usuário"
            v-model="usuario.email"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <a v-bind:href="usuario.url_imagem_perfil" target="_blankt" v-if="usuario.url_imagem_perfil">
            <v-text-field
              readonly
              label="Imagem do usuário"
              value="Clique aqui"
            >
            </v-text-field>
          </a>
        </v-flex>
        </v-stepper-content>
        <v-stepper-content step="2">
        <template v-if="usuario.endereco">
          <v-flex xs12 class="text-xs-center md-2"><h3>Endereço</h3></v-flex>
          <v-flex xs12>
            <v-text-field
              readonly
              label="CEP"
              mask="#####-###"
              v-model="usuario.endereco.cep"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              readonly
              label="Logradouro"
              v-model="usuario.endereco.logradouro"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              readonly
              label="Número"
              v-model="usuario.endereco.numero"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              readonly
              label="Bairro"
              v-model="usuario.endereco.bairro"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              readonly
              label="Cidade"
              v-model="usuario.endereco.cidade"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              readonly
              label="Estado"
              v-model="usuario.endereco.estado"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              readonly
              label="País"
              v-model="usuario.endereco.pais"
            ></v-text-field>
          </v-flex>

        </template>
        </v-stepper-content>
        <v-stepper-content step="3">
        <template v-if="usuario.tem_empresa">
          <v-flex xs12 class="text-xs-center pt-2"><h3>Empresas</h3></v-flex>
          <table class="v-datatable v-table theme--light">
            <thead>
              <tr>
                <th>Nome fantasia</th>
                <th>CNPJ</th>
                <th>Cidade</th>
                <th>Estado</th>
                <th>Imagem</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in empresasUsuario.results" :key="item.cnpj">
                <td>{{ item.nome_fantasia }}</td>
                <td>{{ item.cnpj }}</td>
                <td>{{ item.endereco.cidade }}</td>
                <td>{{ item.endereco.estado }}</td>
                <td v-if="item.url_logo">
                  <a :href="item.url_logo" target="_blankt">Clique aqui</a>
                </td>
                <td v-else>N/A</td>
              </tr>
            </tbody>
          </table>
          <br />
          <v-container>
            <v-layout row wrap text-xs-center>
            <v-flex xs4>
            <v-btn
              v-if="empresasUsuario.count > 5"
              :disabled="pageEmpresa == 1"
              @click="
                pageEmpresa -= 1
                empresasPorUsuario()
              "
              >Página anterior</v-btn
            >
            </v-flex>
            <v-flex xs4>
              <div v-if="empresasUsuario.count > 5" class="mt-3">
                {{ (pageEmpresa - 1) * 5 + 1 }}-{{ pageEmpresa * 5 }} de
                {{ empresasUsuario.count }}
              </div>
            </v-flex>
            <v-flex xs4>
              <v-btn
                v-if="empresasUsuario.count > 5"
                :disabled="empresasUsuario.next == null"
                @click="
                  pageEmpresa += 1
                  empresasPorUsuario()
                "
                >Próxima página</v-btn
              >
            </v-flex>
          </v-layout>
        </v-container>
        </template>
        </v-stepper-content>
        <v-stepper-content step="4">
        <template v-if="usuario.tem_posto">
          <v-flex xs12 class="text-xs-center mb-1 pt-2"><h3>Postos</h3></v-flex>
          <table class="v-datatable v-table theme--light">
            <thead>
              <tr>
                <th>Nome fantasia</th>
                <th>CNPJ</th>
                <th>Cidade</th>
                <th>Estado</th>
                <th>Imagem</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in postos.results" :key="item.cnpj">
                <td>{{ item.nome_fantasia }}</td>
                <td>{{ item.cnpj }}</td>
                <td>{{ item.endereco.cidade }}</td>
                <td>{{ item.endereco.estado }}</td>
                <td v-if="item.url_logo">
                  <a :href="item.url_logo" target="_blankt">Clique aqui</a>
                </td>
                <td v-else>N/A</td>
              </tr>
            </tbody>
          </table>
          <br />
          <v-container>
            <v-layout row wrap text-xs-center>
            <v-flex xs4>
            <v-btn
              v-if="postos.count > 5"
              :disabled="pagePosto == 1"
              @click="
                pageEmpresa -= 1
                postosPorUsuario()
              "
              >Página anterior</v-btn
            >
            </v-flex>
            <v-flex xs4>
              <div v-if="postos.count > 5" class="mt-3">
                {{ (pagePosto - 1) * 5 + 1 }}-{{ pagePosto * 5 }} de
                {{ postos.count }}
              </div>
            </v-flex>
            <v-flex xs4>
              <v-btn
                v-if="postos.count > 5"
                :disabled="postos.next == null"
                @click="
                  pagePosto += 1
                  postosPorUsuario()
                "
                >Próxima página</v-btn
              >
            </v-flex>
          </v-layout>
        </v-container>
        </template>
      </v-stepper-content>
      </v-stepper-items>
      </v-stepper>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        flat
        color="primary"
        @click="
          fechar()
        "
        >Voltar</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ['usuario'],
  data () {
    return {
      step: 1,
      pageEmpresa: 1,
      pagePosto: 1,
      postos: {
        results: []
      },
      empresasUsuario: {
        results: []
      }
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    headers () {
      return this.$store.getters.headers
    },
    usuarioDataNascimento: {
      get: function () {
        try {
          return this.usuario.data_nascimento.split('-').reverse().join('/')
        } catch {
          return ' '
        }
      },
      set: function (newValue) {
        try {
          this.usuario.data_nascimento = newValue.split('/').reverse().join('-')
        } catch {
          return ' '
        }
      }
    },
    usuarioDataCadastro () {
      try {
        return this.usuario.data_cadastro
          .split('-')
          .reverse()
          .join('/')
      } catch {
        return ' '
      }
    }
  },
  methods: {
    fechar () {
      this.step = 1
      this.$emit('fechar')
    },
    verificarVariavel (message) {
      try {
        return message
      } catch {
        return ' '
      }
    },
    reiniciarPagina () {
      this.pagePosto = 1
      this.pageEmpresa = 1
    },
    postosPorUsuario () {
      this.$store
        .dispatch('procurarPostosPorUsuario', {
          id_pessoa: this.usuario.id_pessoa,
          page: this.pagePosto
        })
        .then((json) => {
          this.postos = json
        })
    },
    empresasPorUsuario () {
      this.$store
        .dispatch('procurarEmpresasPorUsuario', {
          id_pessoa: this.usuario.id_pessoa,
          page: this.pageEmpresa
        })
        .then((json) => {
          this.empresasUsuario = json
        })
    }
  },
  watch: {
    usuario (val) {
      if (val) {
        this.postosPorUsuario()
        this.empresasPorUsuario()
      }
    }
  },
  mounted () {
    if (this.usuario) {
      this.postosPorUsuario()
      this.empresasPorUsuario()
    }
  }
}
</script>
<style>
.v-navigation-drawer {
  transition: none !important
}

.lightbox {
  box-shadow: 0 0 20px inset rgba(0, 0, 0, 0.2);
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.4) 0%,
    transparent 72px
  )
}
</style>
